/* eslint-disable */

import Colors from '../../Support/Theme/Colors/Colors';

/**
 * Create styles for `<HereMaps />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<HereMaps />` styles
 */
const HereMapsStyles = ({ theme }) => ({
  map: {
    height: theme.spacing(1) * 40,
  },
  errorText: {
    color: Colors.california[900],
  },
  callBoralLink: {
    color: theme.palette.error.main,
  },
});

export default HereMapsStyles;
